/**
 * Event names and TypeScript interfaces for PostHog analytics
 *
 * Note: Session tracking is handled automatically by PostHog
 * Use $session_id property in PostHog to analyze user sessions
 */

// Event Constants
export const AUTH_EVENTS = {
  USER_SIGNED_UP: "user_signed_up",
  USER_LOGGED_IN: "user_logged_in",
  USER_LOGIN_FAILED: "user_login_failed",
  USER_LOGGED_OUT: "user_logged_out",
  MFA_REQUIRED: "mfa_required",
  MFA_VERIFIED: "mfa_verified"
} as const;

export const NAVIGATION_EVENTS = {
  PAGE_VIEWED: "$pageview"
} as const;

export const MODAL_EVENTS = {
  MODAL_OPENED: "modal_opened",
  MODAL_CLOSED: "modal_closed",
  MODAL_BACKDROP_CLICKED: "modal_backdrop_clicked"
} as const;

export const GRAPHQL_EVENTS = {
  GRAPHQL_OPERATION_EXECUTED: "graphql_operation_executed",
  GRAPHQL_ERROR: "graphql_error"
} as const;

export const API_ERROR_EVENTS = {
  API_ERROR: "api_error",
  API_RETRY_ATTEMPTED: "api_retry_attempted",
  TOKEN_REFRESH_FAILED: "token_refresh_failed"
} as const;

// TypeScript Interfaces
export interface BaseEventProperties {
  user_id?: string;
  user_role?: string;
  organisation_id?: string;
  page_path?: string;
  page_title?: string;
  referrer?: string;
  [key: string]: any;
}

export interface AuthEventProperties extends BaseEventProperties {
  email?: string;
  mfa_type?: "EMAIL_OTP" | "SMS_MFA" | "SOFTWARE_TOKEN_MFA";
  error_message?: string;
  error_type?: string;
}

export interface ModalEventProperties extends BaseEventProperties {
  modal_type: string;
  close_method?: "button" | "backdrop" | "escape";
}

export interface GraphQLEventProperties extends BaseEventProperties {
  method_name: string;
  method_type: "query" | "mutation";
  success: boolean;
  error_message?: string;
  error_type?: string;
  request_payload?: any;
  response_data?: any;
}

export interface APIErrorEventProperties extends BaseEventProperties {
  endpoint: string;
  method: string;
  status_code?: number;
  error_message: string;
  error_type?: string;
  retry_count?: number;
}
